import { FileClockIcon } from 'lucide-react'

import { ProcessDocumentButton, useDocument } from '@/modules/documents'

export const DocumentNotStarted = () => {
  const document = useDocument()
  if (!document) return

  return (
    <div className="flex flex-1 self-start flex-col items-center justify-center gap-4 rounded-lg border py-24 text-center bg-white">
      <div className="rounded-full bg-muted p-4">
        <FileClockIcon className="size-8 text-muted-foreground" />
      </div>
      <div className="space-y-1.5">
        <h3 className="text-lg font-semibold">Not yet processed</h3>
        <p className="text-sm text-muted-foreground">
          Process this document to extract its content and make it searchable.
        </p>
      </div>
      <ProcessDocumentButton>Process documents</ProcessDocumentButton>
    </div>
  )
}
